import ReactGA from 'react-ga4';

function init() {
  // const g_id = import.meta.env.VITE_GA4_TRACKING_ID;
  const g_id = process.env.GA4_TRACKING_ID as string;
  ReactGA.initialize(g_id);
}

export const EventClearCanvas = {
  category: 'playground',
  action: 'extractor_click',
  label: 'clear_canvas'
};

export const EventUpload = {
  category: 'playground',
  action: 'extractor_click',
  label: 'user_upload'
};

export const EventUploadCancel = {
  category: 'playground',
  action: 'extractor_click',
  label: 'user_upload_cancel'
};

export const EventOpenSample = (label: string) => ({
  category: 'playground',
  action: 'open_sample',
  label: label
});

export const EventResultCopy = {
  category: 'playground',
  action: 'extractor_click',
  label: 'result_copy'
};

export const EventResultDownload = {
  category: 'playground',
  action: 'extractor_click',
  label: 'result_download'
};

export const EventResultFilter = {
  category: 'playground',
  action: 'extractor_click',
  label: 'result_filter'
};

//Event Function Overloading
const preEvent = ReactGA.event;
ReactGA.event = (payload) => {
  try {
    // const newEvent = { ...payload, category: payload.action, action: payload.category };
    preEvent(payload);
  } catch (err) {}
};

const preSend = ReactGA.send;
ReactGA.send = (payload) => {
  preSend(payload);
};

export default ReactGA;
export { init };
